import { render } from "./dealerDetails.vue?vue&type=template&id=86587540&ts=true"
import script from "./dealerDetails.vue?vue&type=script&lang=ts"
export * from "./dealerDetails.vue?vue&type=script&lang=ts"

import "./dealerDetails.vue?vue&type=style&index=0&id=86587540&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__